import React, { forwardRef, useMemo } from 'react'
import { FieldTypes, urlRegexValidator } from 'utils/formUtils';
import SonarcloudMappingFormV2 from './SonarcloudMappingFormV2';
import GenericPullCredentialsForm from '../GenericPullCredentialsForm';

function SonarcloudCredentialsForm(props, ref) {
    
    const tokenAuthFields = useMemo(() => ([{
        name: "token",
        label: "Token",
        type: FieldTypes.PASSWORD,
        required: true
    }]),[]);

    const fields = useMemo(() => {
        const authFieled =  tokenAuthFields;
        return (
            [{
                name: "apiEndpoint",
                label: "API Endpoint",
                required: true,
                rules:[urlRegexValidator],
            },
            ...authFieled]
        );
    },[tokenAuthFields])

    return (
        <GenericPullCredentialsForm
            {...props}
            ref={ref}
            fields={fields}
            MappingForm={SonarcloudMappingFormV2}
            initialValue={{ apiEndpoint: 'https://sonarcloud.io' }}
        />
    )
}

export default forwardRef(SonarcloudCredentialsForm);